export default "__VITE_ASSET__2gjl0KyO__"